// extracted by mini-css-extract-plugin
export default {"pill":"SiteTag_pill__E68wx","compact":"SiteTag_compact__a7SWr","default":"SiteTag_default__WbsgN"};